import React, { useState } from 'react';
import { Dialog, Grid, Typography, Button } from '@mui/material';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { poppins500, poppins400 } from 'theme/common.style';
import PrivateOfferCancelled from './PrivateOfferCancelled';

const PrivateOfferCancel = ({
  confirmCancel,
  setConfirmCancel,
  getBuyerIndividualValue,
  isSmallHeight,
  matchessm,
  matchesmd,
  setIsPaused,
  onClose,
  setManageOffer,
  groupIt,
  groupCall,
}) => {
  const [openCancelled, setOpenCancelled] = useState(false);
  return (
    <>
      <Dialog
        open={confirmCancel}
        PaperProps={{
          sx: {
            height: isSmallHeight ? 'auto' : matchessm ? 'auto' : 'auto',
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
        zIndex={200000}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '10px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>

            <Grid item display={'flex'} alignItems={'center'}>
              <Pendingwarning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  color: '#000000',
                }}
              >
                <Grid
                  item
                  display={'flex'}
                  alignItems={'center'}
                  padding={'12px 0px 15px 0'}
                >
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: matchessm ? '16px' : '24px',
                      paddingLeft: '8px',
                      color: '#000000',
                    }}
                  >
                    Cancel Offer
                  </Typography>
                </Grid>
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: '0px',
                  marginLeft: '3px',
                  justifyItems: 'self-end',
                }}
              >
                Would you like to cancel the vendor accepted private offer?
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            gap={2}
            marginTop={matchessm ? '60px' : '20px'}
            justifyContent={'end'}
          >
            <Grid item sx={{ marginTop: '8px' }}></Grid>
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => {
                  setConfirmCancel(false);
                  setIsPaused(false);
                }}
              >
                Back
              </Button>
            </Grid>
            <Grid
              item
              onClick={() => {
                setConfirmCancel(false);
                setOpenCancelled(true);
                onClose();
              }}
            >
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchesmd ? '12px' : '14px',
                  backgroundColor: '#4CA4D6',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Yes
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <PrivateOfferCancelled
        openCancelled={openCancelled}
        setOpenCancelled={setOpenCancelled}
        getBuyerIndividualValue={getBuyerIndividualValue}
        isSmallHeight={isSmallHeight}
        matchessm={matchessm}
        onClose={onClose}
        setManageOffer={setManageOffer}
        groupIt={groupIt}
        groupCall={groupCall}
      />
    </>
  );
};
export default PrivateOfferCancel;
